import React from 'react';
import { Button } from '@mantine/core';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { IconEdit, IconTrash } from '@tabler/icons-react';

export const DeleteRecords = ({ id, endpoint, compcode, onDeleteSuccess }) => {
  const handleDelete = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This record will be deleted!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${process.env.REACT_APP_API_URL}/${endpoint}/${id}/${compcode}`)
          .then((res) => {
            if (res.data.status) {
              Swal.fire('Deleted!', 'Record has been deleted.', 'success');
              if (onDeleteSuccess) {
                onDeleteSuccess(id);
              }
            } else {
              Swal.fire('Error!', res.data.message || 'Delete failed.', 'error');
            }
          })
          .catch(() => {
            Swal.fire('Error!', 'An error occurred while deleting.', 'error');
          });
      }
    });
  };

  return (
    <Button size="xs" color="red" onClick={handleDelete}>
       <IconTrash  size={16} />
    </Button>
  );
};

export const EditRecord = ({ id, route = '/dashboard' }) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(route, { state: { id } });
  };

  return (
    <Button size="xs" onClick={handleEdit}>
       <IconEdit size={16} />
    </Button>
  );
};
